export default defineNuxtPlugin(() => {
  // Ce plugin s'assure que Firebase est correctement initialisé côté client
  // VueFire gère déjà l'initialisation via nuxt.config.ts
  
  // Vérification que la configuration Firebase est disponible
  const config = useRuntimeConfig();
  
  if (!config.public.firebaseConfig?.projectId) {
    console.warn('Configuration Firebase manquante dans runtimeConfig');
  }
  
  // Log pour debug
  console.log('🔥 Firebase plugin chargé - ProjectId:', config.public.firebaseConfig?.projectId);
});
